export default __webpack_public_path__ + "static/media/060_corner2.vp9.6b5166a3.webm";